export default "__VITE_ASSET__DiHUqmHT__"